import { UuidGenerator } from '@standardnotes/utils';
import { KeySystemPasswordType, KeySystemRootKeyStorageMode, FillItemContentSpecialized, } from '@standardnotes/models';
import { ContentType } from '@standardnotes/domain-core';
export class CreateVault {
    constructor(mutator, encryption, keys, sync) {
        this.mutator = mutator;
        this.encryption = encryption;
        this.keys = keys;
        this.sync = sync;
    }
    async execute(dto) {
        const keySystemIdentifier = UuidGenerator.GenerateUuid();
        const rootKey = await this.createKeySystemRootKey({
            keySystemIdentifier,
            vaultName: dto.vaultName,
            vaultDescription: dto.vaultDescription,
            userInputtedPassword: dto.userInputtedPassword,
            storagePreference: dto.storagePreference,
        });
        await this.createKeySystemItemsKey(keySystemIdentifier, rootKey.token);
        const vaultListing = await this.createVaultListing({
            keySystemIdentifier,
            vaultName: dto.vaultName,
            vaultDescription: dto.vaultDescription,
            vaultIcon: dto.vaultIcon,
            passwordType: dto.userInputtedPassword ? KeySystemPasswordType.UserInputted : KeySystemPasswordType.Randomized,
            rootKeyParams: rootKey.keyParams,
            storage: dto.storagePreference,
        });
        await this.sync.sync();
        return vaultListing;
    }
    async createVaultListing(dto) {
        const content = {
            systemIdentifier: dto.keySystemIdentifier,
            rootKeyParams: dto.rootKeyParams,
            keyStorageMode: dto.storage,
            name: dto.vaultName,
            description: dto.vaultDescription,
            iconString: dto.vaultIcon,
        };
        return this.mutator.createItem(ContentType.TYPES.VaultListing, FillItemContentSpecialized(content), true);
    }
    async createKeySystemItemsKey(keySystemIdentifier, rootKeyToken) {
        const keySystemItemsKey = this.encryption.createKeySystemItemsKey(UuidGenerator.GenerateUuid(), keySystemIdentifier, undefined, rootKeyToken);
        await this.mutator.insertItem(keySystemItemsKey);
    }
    async createKeySystemRootKey(dto) {
        let newRootKey;
        if (dto.userInputtedPassword) {
            newRootKey = this.encryption.createUserInputtedKeySystemRootKey({
                systemIdentifier: dto.keySystemIdentifier,
                userInputtedPassword: dto.userInputtedPassword,
            });
        }
        else {
            newRootKey = this.encryption.createRandomizedKeySystemRootKey({
                systemIdentifier: dto.keySystemIdentifier,
            });
        }
        if (dto.storagePreference === KeySystemRootKeyStorageMode.Synced) {
            await this.mutator.insertItem(newRootKey, true);
        }
        else {
            this.keys.cacheKey(newRootKey, dto.storagePreference);
        }
        return newRootKey;
    }
}
